import {EditorState, Transaction} from "prosemirror-state";
import {EditorView} from "prosemirror-view";

import {TriggerActionCommandAdditionalParams} from "./types";
import {insertNode} from "./utils";
import {schema} from "../../config/schema";

export const insertCallout = (
    state: EditorState,
    dispatch?: (tr: Transaction) => void,
    view?: EditorView,
    additionalParams?: TriggerActionCommandAdditionalParams
) => {
    const calloutNode = schema.nodes.callout.createAndFill()!;
    return insertNode(calloutNode, state, dispatch, view, additionalParams);
};

